import Vue from 'vue';

const success = (data, context, limit, activeNum) => {
    var bookings = data.bookings;

  var thread_cnt = 0;
    var threads = [];

    for(var i=0; i<bookings.length; i++) {
        let user_threads = bookings[i];
        if(user_threads.length != 0) {
            threads[thread_cnt++] = Object.assign(user_threads);
        }
    }

    function gnomeSort(arr, searchKey) {
        function moveBack(i) {
            for (; i > 0 && arr[i - 1][searchKey] < arr[i][searchKey]; i--) {
                var t = arr[i];
                arr[i] = arr[i - 1];
                arr[i - 1] = t;
            }
        }

        for (var i = 1; i < arr.length; i++) {
            if (arr[i - 1][searchKey] < arr[i][searchKey]) {
                moveBack(i);
            }
        }
        return arr;
    }

    function sortBy(array) {
      var filterA, filterB;
      return array.sort(function (a, b) {
          filterA = a.created_at;
          filterB = b.created_at;
          return (filterA > filterB) ? 1 : -1;
      })
    }


    threads = gnomeSort(threads, 'unread');
    threads = gnomeSort(threads, 'last_message_at_unix');

    for(var k = 0; k < threads.length; k++) {
        threads[k].messages = sortBy(threads[k].messages);
    }

    context.threads = threads;
    context.loading = false;
    context.messagesLoading = false;
    context.threadDetails = data.threadDetails;
    context.airbnbAccountToken = data.token;
    context.setActiveThread(activeNum, data.bookingId !== '' ? data.bookingId : data.bookingWithThread, null, true);

    if(data.currentPage) {
      context.currentPage = data.currentPage;
    }
    if(data.changeOffsetPast) {
      context.offsetPast++;
    }
    if(data.last) {
      context.isLastPage = true;
    } else {
      context.isLastPage = false;
    }

    if (data.authErrors) {
      let authErrors = data.authErrors;
      for(let error of authErrors){
        toastr.error(context.$t("account.settings.user_platforms_section.airbnb_auth_error") + " " + error);
      }
    }
};

const failed = (error, context) => {
  context.loading = false;
  context.messagesLoading = false;
};

export default (context, limit, page, searchText = false, isFuture = null, offsetFuture = null, offsetPast = null, bookingId = null, activeNum = 0) => {
  context.messagesLoading = true;
  context.loading = true;
  return Vue.$http.get(`get-web-threads-list?id=${bookingId}&limit=${limit}&page=${page}&searchText=${searchText}&isFutureBooking=${isFuture}&offsetFuture=${offsetFuture}&offsetPast=${offsetPast}`).then((response) => {
    if (response && response.status === 200) {
      success(response.data, context, limit, activeNum != null ? activeNum : 0);
    }
  })
  .catch((error) => {
    failed(error, context);
  });
};



// WEBPACK FOOTER //
// ./src/app/services/message/getThreads.js